import React, { Component, Fragment } from 'react';
import {message } from 'antd';
import i18n from "../../../../../../constants/initLng";
import Input from '../../../../common/component/Input';
import * as HMS from '../../../../common/component/Index';
import * as Func from '../../../../../../helpers/functions';
import './style.less';
import UploadImage from "../../../../common/component/UploadImage";
import Wrapper from "../../../../common/component/Wrapper";
import DEFINE from '../../../../../../constants/Define';
import Switch from '../../../../common/component/Switch';

export default class BasicInfo extends Component {

    constructor(props) {
        super(props);
        this.state = {}
    }
    getThumbSources(image) {
        return image ? [`${DEFINE.GENERAL.CDN_IMG_DEFAULT}${image}`] : [];
    }

    render() {
        const { validate } = this.state;
        const { loading, location, isUploading, validation, action } = this.props;
        return (
            <HMS.FormWrapperItem>
                <Wrapper className="col-md-2 col-sm-12">
                    <HMS.FormWrapperInputComponent labelTitle={i18n.t(`item.location.image`)}>
                        <UploadImage
                            multiple={false}
                            loading={isUploading}
                            thumbnailSize={120}
                            buttonSize={120}
                            disabledUpload={loading}
                            disabledRemove={true}
                            uploadText={i18n.t('item.location.uploadFile')}
                            loadingText={i18n.t('item.location.uploading')}
                            onChange={this.props.onUploadImage}
                            onRemoveThumbnail={this.props.onRemoveImage}
                            thumbnails={this.getThumbSources(location.image)} />
                    </HMS.FormWrapperInputComponent>
                </Wrapper>
                <Wrapper className="col-md-4 col-sm-12">
                    <div className="form-group">
                        <HMS.FormWrapperInputComponent
                            isRequired={true}
                            isValidation={true}
                            labelTitle={i18n.t(`item.location.code`)}
                            validation={validation.code}
                        >
                        <Input
                            onChange={this.props.onChange}
                            name={`code`}
                            error={validation.code}
                            value={location.code}
                            disabled={loading}
                            placeholder={i18n.t('item.location.code')}
                            autoFocus/>

                        </HMS.FormWrapperInputComponent>
                    </div>
                    <div className="form-group">
                        <HMS.FormWrapperInputComponent
                            isRequired={true}
                            isValidation={true}
                            validation={validation.name}
                            labelTitle={i18n.t(`item.location.name`)}
                        >
                            <Input
                                onChange={this.props.onChange}
                                name={`name`}
                                value={location.name}
                                error={validation.name}
                                disabled={loading}
                                placeholder={i18n.t('item.location.name')}
                            />
                        </HMS.FormWrapperInputComponent>
                    </div>
                </Wrapper>
                <Wrapper className="col-md-4 col-sm-12">
                    <div className="form-group row">
                        <div className="col-4">
                            <label className="fs15">{i18n.t(`item.location.isActive`)}{location.isActive}</label><br />
                            <Switch defaultChecked={location.isActive} onChange={(value, e) => this.props.onChange({value: value, name: 'isActive'})} name={`isActve`} disabled={loading}/>
                        </div>
                        <div className="col-4">
                            <label className="fs15">{i18n.t(`item.location.isDomestic`)}{location.isDomestic}</label><br />
                            <Switch defaultChecked={action === "CREATE" ? true : location.isDomestic} onChange={(value, e) => this.props.onChange({value: value, name: 'isDomestic'})} name={`isDomestic`} disabled={loading}/>
                        </div>
                    </div>
                    <div className="form-group">
                        <HMS.FormWrapperInputComponent
                            isRequired={false}
                            isValidation={false}
                            labelTitle={i18n.t(`item.location.order`)}
                        >
                        <Input onChange={this.props.onChange} name={`order`}  value={Func.formatMoney(Func.checkUndefine(location.order))} disabled={loading} placeholder={i18n.t('item.location.order')}/>

                        </HMS.FormWrapperInputComponent>
                    </div>
                </Wrapper>
            </HMS.FormWrapperItem>

        );
    }
}

